import React from 'react'
import { useAgentChatSession } from '@/features/medconnect-agent/model/useAgentChatSession'
import { AgentChatLayout } from '@/features/medconnect-agent'

export const MEDCONNECT_AGENT_BASE_PATH = '/medconnect-agent'

/**
 * Full-page ELARA chat. There is a single agent (the `elara` orchestrator): the page/role
 * context travels in `businessMeta`, admin tools are exposed server-side to ADMIN users.
 */
export function MedConnectAgentChatPage() {
  const session = useAgentChatSession({ basePath: MEDCONNECT_AGENT_BASE_PATH })

  return <AgentChatLayout {...session} />
}
